module.exports = __webpack_public_path__ + "static/project1-af9d2e69bbf1d497a760c81b883c15b3.png";